<script>
    import { Statistic, initStatistic, Text, initLabel, Label } from "svantic";
    initLabel(), initStatistic()

    import {
        createBetWs, createBet
    } from "../../../../scripts/stake-api";

    let bet = { }



    export const placeBet =  async (...args) => {
        try {

             let r = await createBetWs(...args)
            if( r.data )
                bet =  r.data 
           
            return r
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return {error: e, data: null}
        }
        finally{

        }
    };
</script>

<Statistic size="huge" inverted>
    <Statistic.Value text={true}>
        {#key bet }
            {#if bet.result}
                <Label.Group circular size="massive" class="extra">                                    
                {#each [... bet.result.result] as dia,i (i) }
                    <Label class={"diamond "+dia}> </Label>    
                {/each}
                </Label.Group>
            {/if}
        {/key}
      
       
    </Statistic.Value>
    <Statistic.Label><Text class="medium">Roll</Text></Statistic.Label>
</Statistic>

<style>
</style>
